<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions"
    (menuOpened)="onAccountMenuOpened()"
    (menuClosed)="onAccountMenuClosed()"
>
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <div class="h-11 w-11 overflow-hidden rounded-full">
                <img class="h-full w-full object-cover" [src]="user.avatar" />
            </div>
        }
        @if (!showAvatar || !user.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        <!-- TODO: Status dot - hidden until real presence tracking is implemented
        <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user.avatar,
                'bg-green-500': user.status === 'online',
                'bg-amber-500': user.status === 'away',
                'bg-red-500': user.status === 'busy',
                'bg-gray-400': user.status === 'not-visible',
            }"
        ></span>
        -->
    </span>
</button>

<mat-menu
    class="user-account-menu"
    [xPosition]="'before'"
    #userActions="matMenu"
>
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="openProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <!-- Settings — available to all roles (traders get a trimmed panel:
         theme color + landing workspace only) -->
    <button mat-menu-item (click)="openSettings()">
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>
    </button>
    @if (user?.role === 'Admin') {
    <div mat-menu-item (click)="$event.stopPropagation()" class="flex items-center justify-between">
        <div class="flex items-center">
            <mat-icon [svgIcon]="'heroicons_outline:cpu-chip'"></mat-icon>
            <span class="ml-2">Agent</span>
        </div>
        <mat-slide-toggle
            [checked]="agentEnabled"
            (change)="toggleAgent($event.checked)"
            color="primary"
            class="ml-4">
        </mat-slide-toggle>
    </div>
    }
    <!-- GTX print agent — download the helper agent to run on a print-station PC.
         Hidden for Sales (no print station / production role). -->
    <a
        *ngIf="gtxEnabled && user?.role !== 'Sales'"
        mat-menu-item
        [href]="gtxAgentDownloadUrl"
        download
    >
        <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
        <span>GTX print agent</span>
    </a>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (pointerdown)="signOut($event)"
        (click)="signOut($event)"
    >
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<!-- TODO: Status submenu - hidden until real presence tracking is implemented
<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
-->
